import { useIntersectionObserver } from 'usehooks-ts';
const useTableStickyHeader = () => {
    const { isIntersecting, ref } = useIntersectionObserver({ threshold: 0.1 });
    return { isHeaderSticky: !isIntersecting, stickyAnchorRef: ref };
};
export { useTableStickyHeader };
